// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"5a2373f3","551":"e5883efa","842":"e0980312"}[chunkId] + ".chunk.js";
};